import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 600 400"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#02219d",
      d: "M0 0h600v400H0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M368.822 251.007c4.52-6.723 4.135-21.44-4.903-26.636-6.914-3.457-14.723-2.104-18.371.872-5.874 3.553-11.53 14.914-11.53 26.42l20.28-.026-.005 22.647-42.093-.022c.551 11.648 6.903 20.979 18.723 26.174-1.522 4.909-8.65 14.915-18.44 14.237-1.932 10.588-3.768 16.532-12.57 26.152-8.808-9.618-10.645-15.564-12.577-26.152-9.79.678-16.917-9.328-18.44-14.237 11.821-5.195 18.173-14.526 18.724-26.174l-42.096.022v-22.647l20.276.025c0-11.505-5.649-22.866-11.528-26.42-3.648-2.973-11.454-4.326-18.366-.871-9.043 5.195-9.431 19.916-4.911 26.636-42.707-7.93-38.47-49.174-23.922-64.147 11.759-12.096 24.577-13.986 34.462-10.172 22.465 8.054 37.573 34.89 38.307 74.974h11.747c0-36.44-6.34-48.057-22.86-93.824-8.322-21.629-3.323-48.369 11.552-72.99 5.328-8.825 11.983-16.791 19.632-25.323 7.643 8.532 14.298 16.498 19.626 25.322 14.875 24.622 19.873 51.362 11.558 72.991-16.529 45.767-22.87 57.382-22.87 93.824h11.748c.734-40.085 15.848-66.92 38.307-74.974 9.885-3.812 22.712-1.924 34.464 10.172 14.546 14.973 18.783 56.217-23.924 64.147"
    }, null, -1)
  ])))
}
export default { render: render }